export default {
  init() {
    // JavaScript to be fired on the about us page
  },
};



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/web/app/themes/main-theme/resources/assets/scripts/routes/about.js